<template>
	<v-container class="mt-4 ml-2" fluid>
		<v-row>
			<v-col cols="12">
				<v-card class="shadowCard">
					<v-card-title primary-title>
						<span class="text-subtitle-1"><v-icon left>mdi-fingerprint</v-icon>Nómina Semanal</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  hide-details
                  item-text="ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>

				      <v-col cols="12" sm="6" md="3" lg="2">
				      	<v-select
				      	:items="semanasSelector"
				      	v-model="selectedHeaders"
				      	label="# Semana"
				      	filled
                  dense
				      	hide-details
				      	item-text="bloque"
				      	item-value="value"
				      	:disabled="!semanasSelector.length"
				      	></v-select>
				      </v-col> 


				      <v-col cols="12" md="3" lg="2">
				      	<v-radio-group
						      v-model="tipoNomina"
						      column
						      hide-details
						      small
						      class="mt-0 pt-0"
						    >
						      <v-radio
						      	v-if="puedeVerNominaAdministrativa"
						        label="Administrativa"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Teachers"
						        :value="2"
						      ></v-radio>
						    </v-radio-group>
				      </v-col> 

				    </v-row>

				    <v-row>
				    	<v-col cols="12">
				    		<Administrativa 
				    			v-if="tipoNomina == 1 && puedeVerNominaAdministrativa && ciclo && selectedHeaders"
				    			:selectedHeaders="selectedHeaders"
				    			:ciclo="ciclo"
				    			:ciclosLista="ciclos"
				    			:fecha="fecha"
				    		/>

				    		<TeacherSabatina 
				    			v-if="tipoNomina == 2 && tipoNominaT == 1 && getdatosUsuarioERPERP.iderp != 568"
				    			:selectedHeaders="selectedHeaders"
				    			:ciclo="ciclo"
				    		/>
				    		<TeacherQuinceca 
				    			v-if="tipoNomina == 2 && tipoNominaT == 2 && getdatosUsuarioERPERP.iderp != 568"
				    			:selectedHeaders="selectedHeaders"
				    			:ciclo="ciclo"
				    			:fecha="fecha"
				    		/>
				    	</v-col>
				    </v-row>
			    </v-card-text>
				</v-card> 
			</v-col>
		</v-row>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';


	import Administrativa        from '@/components/nomina/Administrativa.vue';
	import TeacherSabatina       from '@/components/nomina/TeacherSabatina.vue';
	import TeacherQuincena       from '@/components/nomina/TeacherQuincena.vue';

	import validarErrores  from '@/mixins/validarErrores'
	import XLSX            from 'xlsx'
	import funcionesExcel  from '@/mixins/funcionesExcel'
	import mixinNominaAdministrativaGuard from '@/mixins/mixinNominaAdministrativaGuard'


	export default {
		components:{
			Alerta,
			carga,
			Administrativa,
			TeacherSabatina,
			TeacherQuincena
		},

		mixins: [ validarErrores, funcionesExcel, mixinNominaAdministrativaGuard ],

		data: () => ({
    	// Alertas
			parametros:{
				dialogError: false,
				mensaje: '',
				color: ''
			},

			respuestaAlerta:false,
			loader: true,
			cargar: false,

			encabezados: null,
			encabezados2: null,
			dialogAceptar: false,
			dialogActualizar: false,
			ciclos:[],
			gruposRoles: [],
			pagos: [],
			ciclo:null,
			id_ciclo: 0,

      // Filtros: 
			fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

			page: 1,
			page2: 1,
			pageCount: 0,
			itemsPerPage: 10,
			entradassalidas: [],
			autorizarNomina: [],
			nominaEstatus: [],
			nominaTeachersSabatino: [],
			nominaTeachersCatorcena: [],
			asistencias: [],
			estatus: null,
			entradassalidasteachers: [],

			selectedHeaders:null,
			semanasCiclo: [],
			_configurandoFiltros: false,
			gruposRoles2:[],

			tipoNominaT: 1,
			tipoNomina: null
		}),

		watch: {
			ciclo( value, oldValue ){
				if( !value || this._configurandoFiltros ) return
				if( oldValue && oldValue.id_ciclo !== value.id_ciclo ){
					this.actualizarSemanas()
				}
			},
			tipoNomina( value, oldValue ){
				if( value === 1 && !this.puedeVerNominaAdministrativa ){
					this.tipoNomina = 2
					this.asegurarAccesoNominaAdministrativa()
					return
				}
				this.remapearSemanaPorTipo(oldValue, value)
			},
		},

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			semanasSelector() {
				const semanas = this.semanasCiclo || []
				if (this.tipoNomina === 2) {
					return semanas
						.filter(s => s.semanaNomina)
						.map(s => ({ ...s, value: s.semanaNomina }))
				}
				return semanas
			},

		},

		async created () {
			await this.cargarCiclos()
			if( !this.puedeVerNominaAdministrativa ){
				this.tipoNomina = 2
			}
		},

		methods: {

			calcularSemanasCiclo( ciclo ){
				if( !ciclo || !ciclo.fecha_inicio_ciclo || !ciclo.fecha_fin_ciclo ) return []

				const parseDate = ( fecha ) => new Date(fecha.substr(0, 10) + 'T12:00:00')
				const formatDate = ( fecha ) => fecha.toISOString().substr(0, 10)

				const inicio = parseDate(ciclo.fecha_inicio_ciclo)
				const fin = parseDate(ciclo.fecha_fin_ciclo)
				const semanas = []
				let current = new Date(inicio)
				let num = 1

				while( current <= fin ){
					const weekStart = new Date(current)
					const weekEnd = new Date(current)
					weekEnd.setDate(weekEnd.getDate() + 6)
					if( weekEnd > fin ) weekEnd.setTime(fin.getTime())

					semanas.push({
						bloque: `Semana ${ num }`,
						value: num,
						fecha_inicio: formatDate(weekStart),
						fecha_fin: formatDate(weekEnd),
					})

					num++
					current.setDate(current.getDate() + 7)
				}

				this.etiquetarSemanasCiclo( semanas )
				return semanas
			},

			etiquetarSemanasCiclo( semanas ){
				const total = semanas.length
				if( total < 5 ){
					semanas.forEach((s, i) => { s.semanaNomina = i + 1 })
					return
				}

				for( let i = 0; i < total; i++ ){
					const num = i + 1
					if( num === 1 ){
						semanas[i].bloque = 'Semana 1'
						semanas[i].semanaNomina = 1
					} else if( num === 2 ){
						semanas[i].bloque = 'Semana 2'
						semanas[i].semanaNomina = 2
					} else if( num === total - 1 ){
						semanas[i].bloque = 'Semana 3'
						semanas[i].semanaNomina = 3
					} else if( num === total ){
						semanas[i].bloque = 'Semana 4'
						semanas[i].semanaNomina = 4
					} else {
						semanas[i].bloque = `Semana vacaciones ${ num - 2 }`
						semanas[i].semanaNomina = null
					}
				}
			},

			semanasTeachers() {
				return (this.semanasCiclo || []).filter(s => s.semanaNomina)
			},

			remapearSemanaPorTipo(tipoAnterior, tipoNuevo) {
				if (!this.semanasCiclo.length || !tipoNuevo) return
				const actual = this.selectedHeaders

				if (tipoNuevo === 2) {
					const sem = this.semanasCiclo.find(s => s.value === actual)
					if (sem && sem.semanaNomina) {
						this.selectedHeaders = sem.semanaNomina
						return
					}
					const teaching = this.semanasTeachers()
					const porFecha = teaching.find(el => this.fecha >= el.fecha_inicio && this.fecha <= el.fecha_fin)
					this.selectedHeaders = porFecha
						? porFecha.semanaNomina
						: ((teaching[teaching.length - 1] || {}).semanaNomina || null)
					return
				}

				if (tipoNuevo === 1 && tipoAnterior === 2) {
					const sem = this.semanasCiclo.find(s => s.semanaNomina === actual)
					this.selectedHeaders = sem
						? sem.value
						: this.semanasCiclo[this.semanasCiclo.length - 1].value
				}
			},

			actualizarSemanas(){
				this.semanasCiclo = this.calcularSemanasCiclo(this.ciclo)

				if( !this.semanasCiclo.length ){
					this.selectedHeaders = null
					return
				}

				const semanaActual = this.semanasCiclo.find(
					el => this.fecha >= el.fecha_inicio && this.fecha <= el.fecha_fin
				)

				if (this.tipoNomina === 2) {
					const teaching = this.semanasTeachers()
					if (semanaActual && semanaActual.semanaNomina) {
						this.selectedHeaders = semanaActual.semanaNomina
					} else {
						this.selectedHeaders = (teaching[teaching.length - 1] || {}).semanaNomina || null
					}
					return
				}

				this.selectedHeaders = semanaActual
					? semanaActual.value
					: this.semanasCiclo[this.semanasCiclo.length - 1].value
			},

			async cargarCiclos(){
				this._configurandoFiltros = true
				this.cargar = true
				this.ciclos = []

				try{
					const response = await this.$http.post('roles.get.ciclos.minomina', { fecha: this.fecha })
					this.ciclos = response.data.ciclos || []

					const cicloActual = response.data.ciclo_actual
					if( cicloActual ){
						this.ciclo = this.ciclos.find(el => el.id_ciclo === cicloActual.id_ciclo) || cicloActual
					}else if( this.ciclos.length ){
						this.ciclo = this.ciclos.find(el => {
							const inicio = el.fecha_inicio_ciclo.substr(0, 10)
							const fin = el.fecha_fin_ciclo.substr(0, 10)
							return this.fecha >= inicio && this.fecha <= fin
						}) || this.ciclos[0]
					}

					if( this.ciclo ){
						this.actualizarSemanas()
					}
				}catch( error ){
					let msg = 'Error al cargar ciclos'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}finally{
					this._configurandoFiltros = false
					this.cargar = false
				}
			},
		},
	}
</script>




